<template>
  <div>
    <el-button @click="dialogVisible = true" type="warning"
      >节点人数统计</el-button
    >
    <el-dialog
      :visible.sync="dialogVisible"
      title="节点人数统计"
      width="1200px"
      @close="closeDialog"
    >
      <div class="page-actions">
        <span>选择时间：</span>
        <el-date-picker
          v-model="times"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-input placeholder="请输入节点ID" v-model="nodeId"></el-input>
        <span>是否激活：</span>
        <el-switch v-model="activate" @change="serch()"></el-switch>
        <el-button type="primary" @click="serch()">查询</el-button>
        <el-button type="success" @click="serchAll()">全部</el-button>
      </div>
      <el-table :data="content">
        <el-table-column prop="nodeId" label="节点ID"></el-table-column>
        <el-table-column prop="count" label="总人数"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Editor from 'components/editor';

export default {
  name: 'CreateContent',
  data() {
    return {
      dialogVisible: false,
      content: {},
      times: [],
      activate: false,
      nodeId: ''
    };
  },
  components: {},
  computed: {
    startTime() {
      return this.times ? this.times[0] : '';
    },
    endTime() {
      return this.times ? this.times[1] : '';
    }
  },
  methods: {
    ...mapActions('setnode', ['nodeList']),
    closeDialog() {
      this.dialogVisible = false;
      this.content = '';
    },
    serch() {
      this.nodeList({
        startTime: this.startTime,
        endTime: this.endTime,
        nodeId: this.nodeId,
        activate: this.activate
      }).then(res => {
        this.content = res.data;
      });
    },
    serchAll() {
      this.nodeList().then(res => {
        this.content = res.data;
      });
    }
  },
  mounted() {
    this.serchAll();
  }
};
</script>

<style lang="less" scoped></style>
